export function extractSnomedCodesFromSummary(consultationSummary) {
  if (!consultationSummary) {
    return { mainSummary: "", snomedCodes: [] };
  }

  const snomedIndex = consultationSummary.indexOf("SnomedCodes:");

  if (snomedIndex === -1) {
    return { mainSummary: consultationSummary, snomedCodes: [] };
  }

  // Extract main summary (everything before "SnomedCodes:")
  const mainSummary = consultationSummary.substring(0, snomedIndex).trim();

  // Extract SNOMED codes array
  const afterSnomed = consultationSummary.substring(
    snomedIndex + "SnomedCodes:".length,
  );
  const arrayStartIndex = afterSnomed.indexOf("[");
  const arrayEndIndex = afterSnomed.lastIndexOf("]");

  let snomedCodes = [];
  if (arrayStartIndex !== -1 && arrayEndIndex !== -1) {
    const jsonString = afterSnomed.substring(
      arrayStartIndex,
      arrayEndIndex + 1,
    );
    try {
      snomedCodes = JSON.parse(jsonString);
    } catch (err) {
      console.error("Failed to parse SNOMED codes:", err);
    }
  }

  return { mainSummary, snomedCodes };
}
